import { openDB } from "idb";
import CryptoJS from "crypto-js";
const DB_NAME = "UserPermissionsDB";
const STORE_NAME = "permissions";
const SECRET_KEY = (process.env.REACT_APP_SECRET_KEY || "SECRET@3210923HGF")
    .replace(/^["']|["']$/g, "")
    .trim();
// console.log("SECRET_KEY:", SECRET_KEY);

const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

const decriptData = (data) => {
    const decrypted = CryptoJS.AES.decrypt(data, SECRET_KEY).toString(CryptoJS.enc.Utf8);
    return decrypted ? JSON.parse(decrypted) : null;
};

export const initDB = async () => {
    return openDB(DB_NAME, 1, {
        upgrade(db) {
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, { keyPath: "id" });
            }
        },
    });
};

export const savePermissions = async (userData) => {
    console.log("user datas", userData)
    try {
        if (!userData?.ROWID) {
            throw new Error("Cannot save permissions without user ROWID");
        }

        const db = await initDB();
        const dataPayload = {
            id: userData?.ROWID, // ✅ MUST be present for keyPath "id"
            ROWID: userData?.ROWID,
            employeeName: userData?.employeeName,
            email: userData?.email,
            phoneNumber: userData?.phoneNumber,
            role: userData?.rolesName,
            // permissionId: userData?.permission?.id || userData?.permissionId,
            permissions: encryptData(userData?.permissions)
        };
        await db.put(STORE_NAME, dataPayload);

        let encryptId = encryptData(userData?.ROWID);
        // let encreyptEmpId = encryptData(userData?.employee?.id);
        localStorage.setItem("id", encryptId);
        // localStorage.setItem('employeeId', encreyptEmpId)
        return true;
    } catch (err) {
        console.log('savePermissions error:', err);
        return false;
    }
};

export const getUserId = async () => {
  const enpId = localStorage.getItem("id"); // Debug step
  if (!enpId) {
    console.log("Error: ID is missing from localStorage!");
    return null; // Prevents calling decriptData on null
  }

  const decrypted = await decriptData(enpId);
  return decrypted;
};


export const getPermissions = async (ROWID) => {
    const db = await initDB();
    const data = await db.get(STORE_NAME, ROWID);
    if (!data?.permissions) return [];
    return decriptData(data.permissions);
};

export const getEmployeeId = () => {
    const encrypted = localStorage.getItem("employeeId");
    if (!encrypted) return null;
    return decriptData(encrypted);
};

export const getUserDetails = async () => {
    try {
        const db = await initDB();

        // Get encrypted id from localStorage
        const encryptedId = localStorage.getItem("id");
        if (!encryptedId) return null;

        const realId = decriptData(encryptedId);

        // Fetch the record using id as key
        const result = await db.get(STORE_NAME, realId);

        return result; // contains employeeName, employeeId, role, permissions, etc.
    } catch (err) {
        console.log("getPermissions error:", err);
        return null;
    }
};

export const clearPermissions = async () => {
  try {
    const db = await initDB();
    const tx = db.transaction(STORE_NAME, "readwrite");
    await tx.objectStore(STORE_NAME).clear(); // ✅ clears all records in "permissions"
    await tx.done;

    localStorage.removeItem("id"); // ✅ remove encrypted ID
    console.log("Permissions & user ID cleared successfully.");
  } catch (err) {
    console.error("Error clearing permissions:", err);
  }
};
